import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './ProgressDashboard.scss';

class ProgressDashboard extends Component {
  static defaultProps = {
    usedNumber: 1,
    limitNumber: 5
  };

  constructor(props) {
    super(props);
    this.state = {
      
    };
  }

  render() {
    const { className = '', usedNumber, limitNumber } = this.props;
    if (!limitNumber) {
      return (<div></div>);
    }
    const progressWidth = (usedNumber / limitNumber) * 100;
    const full = usedNumber === limitNumber;
    return (
      <div className={`progress-dashboard ${className} ${full ? 'progress-dashboard-unlimit' : ''}`}>
        <div className="progress-text">
          <span><strong>{usedNumber} of {limitNumber}</strong> dashboards</span>
          {full && <span className="progress-value">Full</span>}
        </div>
        <div className="progress-track">
          {Array.from({ length: 10 }, (_, i) => (
            <div key={i} className="progress-slot">
              <div className="progress-inner" style={{width: Math.max(0, Math.min(100, (progressWidth - i * 10) * 10)) + "%"}}></div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

ProgressDashboard.propTypes = {
  className: PropTypes.string,
  usedNumber: PropTypes.number,
  limitNumber: PropTypes.number
};

export default ProgressDashboard;
